import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in from localStorage
    const savedUser = localStorage.getItem('mcaUser');
    const savedToken = localStorage.getItem('mcaToken');
    if (savedUser && savedToken) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password, role) => {
    try {
      console.log('Login attempt:', { email, role });
      const response = await authAPI.login(email, password, role);
      console.log('Login response:', response);
      
      const { user: userData, token } = response.data;
      console.log('Extracted user and token:', { userData, token });
      
      setUser(userData);
      localStorage.setItem('mcaUser', JSON.stringify(userData));
      localStorage.setItem('mcaToken', token);
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response);
      return {
        success: false,
        error: error.response?.data?.detail || 'Invalid credentials or role',
      };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('mcaUser');
    localStorage.removeItem('mcaToken');
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
